import {SxProps} from "@mui/material";
import {strokeTheme} from "../../../../config/themes/theme";

export const STYLES = {
  subjectPopperPaper: {
    my: 1,
    py: "20px",
    width: "400px",
    height: "60vh",
    overflow: "scroll",
    position: "relative",
    zIndex: 10,
  } as SxProps,
  subjectPopperButton: {
    width: "120px",
    pt: "20px",
    pb: "16px",
    flexDirection: "column",
    alignItems: "center",
    border: strokeTheme,
    borderRadius: "12px",
    ".MuiButton-startIcon": {
      mx: 0,
    },
  } as SxProps,
  subjectPopperButtonTypography: {
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.025em",
    textTransform: "uppercase",
  } as SxProps,
  subjectPopperSelectButtonText: {
    color: "primary.dark",
    textTransform: "none",
    fontSize: "0.75rem",
  } as SxProps,
  subjectPopperCloseIconBox: {
    position: "absolute",
    right: "12px",
    top: "0px",
    p: "2px",
    borderRadius: "50%",
    color: "secondary.contrastText",
    ":hover": {
      cursor: "pointer",
      bgcolor: "secondary.light",
    },
  } as SxProps,
} as const;
